var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 15,
    width: 11,
    height: 7,
    transform: "rotate(-180 60 15)",
    fill: "#D4D5FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 19,
    width: 20,
    height: 6,
    transform: "rotate(-180 69 19)",
    fill: "#D4D5FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 17,
    width: 18,
    height: 55,
    fill: "#8D84F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 51,
    width: 12,
    height: 10,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 38,
    width: 12,
    height: 10,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 24,
    width: 12,
    height: 10,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 38,
    width: 12,
    height: 10,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 24,
    width: 12,
    height: 10,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 51,
    width: 12,
    height: 21,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 24,
    width: 8,
    height: 10,
    fill: "#5B53B5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 38,
    width: 8,
    height: 10,
    fill: "#5B53B5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 52,
    width: 8,
    height: 10,
    fill: "#5B53B5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 26,
    width: 8,
    height: 3,
    fill: "#D4D5FC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 40,
    width: 8,
    height: 3,
    fill: "#D4D5FC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26,
    width: 8,
    height: 3,
    fill: "#D4D5FC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 40,
    width: 8,
    height: 3,
    fill: "#D4D5FC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 53,
    width: 8,
    height: 3,
    fill: "#D4D5FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 57,
    r: 2,
    fill: "#8D84F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 24V34H31V24H19ZM21 26V32H29V26H21Z",
    fill: "#231C70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 48V38H31V48H19ZM29 40V46H21V40H29Z",
    fill: "#231C70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 34V24H46V34H34ZM36 26H44V32H36V26Z",
    fill: "#231C70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 48V38H46V48H34ZM36 40H44V46H36V40Z",
    fill: "#231C70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 61V51H46V61H34ZM36 53H44V59H36V53Z",
    fill: "#231C70"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 70L67 70V19H69V13L60 13V8L23 8V13H10V19H14V70H7C6.44772 70 6 70.4477 6 71C6 71.5523 6.44772 72 7 72L73 72C73.5523 72 74 71.5523 74 71C74 70.4477 73.5523 70 73 70ZM65 70V19L51 19V70L65 70ZM49 70V19H16V70H19V51H31V70H49ZM51 17H67V15L51 15V17ZM49 17V15H12V17H49ZM49 10H25V13H49V10ZM29 53V70H21V53H29ZM51 13L58 13V10L51 10V13Z",
    fill: "#231C70"
  })));
}
export default SvgApartment;